
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M3.062 3.762C3.926 2.898 5.456 2 7.333 2c1.873 0 3.37.86 4.238 1.729a6.207 6.207 0 011.697 3.394l.26-.261a.668.668 0 01.943.943l-1.333 1.333a.668.668 0 01-.888.05l-1.666-1.334a.666.666 0 11.832-1.041l.518.413a4.888 4.888 0 00-1.305-2.555 4.743 4.743 0 00-3.296-1.338c-1.456 0-2.662.705-3.328 1.372A4.734 4.734 0 002.667 8c0 1.456.704 2.662 1.371 3.329a4.738 4.738 0 003.295 1.338.667.667 0 110 1.333c-1.872 0-3.37-.86-4.238-1.729C2.231 11.407 1.333 9.877 1.333 8c0-1.872.86-3.37 1.729-4.238zm4.271 1.905a.666.666 0 10-1.333 0v2.916c0 .193.083.375.228.502l2 1.75a.666.666 0 00.878-1.003L7.333 8.28V5.667z","clip-rule":"evenodd"}})])
          )
        }
      }
    